import { render, staticRenderFns } from "./ContributionCalculator.vue?vue&type=template&id=1a87018d&scoped=true&"
import script from "./ContributionCalculator.vue?vue&type=script&lang=js&"
export * from "./ContributionCalculator.vue?vue&type=script&lang=js&"
import style0 from "./ContributionCalculator.vue?vue&type=style&index=0&id=1a87018d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a87018d",
  null
  
)

export default component.exports